import { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../components/loader";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap"; // Changed from Offcanvas to Modal
import Footer from "../components/footer";

import { API_BASE_URL } from '../config/api';

function Services() {
  const [searchValue, setSearchValue] = useState("");
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [showModal, setShowModal] = useState(false); // Changed from showOffcanvas
  const [selectedService, setSelectedService] = useState(null);
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(null);
  const [isClosing, setIsClosing] = useState(false); // Add closing state for animation

  const serviceType = {
    "one-time": "#d0e8dd",
    renewal: "#cef4fc",
    misc: "#f8d7db",
  };
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowModal(false);
      setIsClosing(false);
    }, 300); // Match the CSS transition duration
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/services/`
        );
        setServices(response.data);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };
    // Call the fetch function to get institutes data
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleCloseModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    fetchData();
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  if (isLoading) return <Loader />;
  if (error) return <div>Error: {error}</div>;

  const filteredServices = services.filter((service) =>
    service.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  // Function to handle opening the modal with smooth animation
  const handleShowModal = (item, index) => {
    setSelectedService(item);
    setSelectedServiceIndex(index);
    setIsClosing(false);
    setShowModal(true);
  };

  // Function to handle closing the modal with smooth animation

  const NextService = () => {
    const currentIndex = filteredServices.findIndex(
      (service) => service.id === selectedService.id
    );
    if (currentIndex < filteredServices.length - 1) {
      const nextService = filteredServices[currentIndex + 1];
      setSelectedService(nextService);
      setSelectedServiceIndex(currentIndex + 1);
    } else {
      console.log("index went out");
    }
  };

  const PrevServices = () => {
    const currentIndex = filteredServices.findIndex(
      (service) => service.id === selectedService.id
    );
    if (currentIndex !== 0) {
      const prevService = filteredServices[currentIndex - 1];
      setSelectedService(prevService);
      setSelectedServiceIndex(currentIndex - 1);
    } else {
      console.log("index went out");
    }
  };

  return (
    <>
      <section className="service-section-banner">
        <div className="services-section-content">
          <h1>Services offered</h1>
          <div className="breadcrumb-link">
            <Link to="/">Home</Link>
            <span></span>
            <p>Services</p>
          </div>
        </div>
      </section>
      <h3 className="py-5 text-center">
        "Navigating your career - resources for every stage of your maritime
        journey"
      </h3>

      <section className="d-flex justify-content-center p-3">
        <div className="container-width mb-5">
          <div className="d-flex justify-content-between services-filters-section">
            <div className="col-xl-3 col-xxl-3 col-md-3 col-lg-3 col-sm-6 col-12">
              <div className="col-12">
                <input
                  type="text"
                  className="form-control mb-4"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Search for Services ..."
                />
              </div>
            </div>
            <div>
              <div className="d-flex flex-column flex-sm-row gap-2 mb-4">
                <p className="fw-bold">Show Services:</p>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    id="all"
                    type="radio"
                    name="service-filter"
                    value="all"
                    checked={selectedFilter === "all"}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="all">
                    All
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    id="one-time"
                    type="radio"
                    name="service-filter"
                    value="one-time"
                    checked={selectedFilter === "one-time"}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="one-time">
                    Documentation 
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    id="renewal"
                    type="radio"
                    name="service-filter"
                    value="renewal"
                    checked={selectedFilter === "renewal"}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="renewal">
                    Documentation Renewal
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    id="misc"
                    type="radio"
                    name="service-filter"
                    value="misc"
                    checked={selectedFilter === "misc"}
                    onChange={(e) => setSelectedFilter(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="misc">
                    Miscellaneous
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4 services3">
            {filteredServices.map((item, index) => (
              <div
                onClick={() => handleShowModal(item, index)}
                className={`col ${
                  selectedFilter !== "all" && item.type !== selectedFilter
                    ? "d-none"
                    : ""
                }`}
                key={item.id}
              >
                <div className="services-card">
                  <div className="service-card-header">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        fill="currentColor"
                        className="bi bi-person-fill-gear"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
                      </svg>
                    </div>
                    <div className="ms-3">
                      <span
                        className="badge me-2"
                        style={{
                          backgroundColor: serviceType[item.type],
                        }}
                      >
                        {item.type === 'one-time'
                          ? 'Documentation'
                          : item.type === 'renewal'
                          ? 'Documentation Renewal'
                          : item.type}
                      </span>
                    </div>
                  </div>
                  <h5>{item.name}</h5>
                  <p6 style={{ fontSize: "14px", color: "#6c757d" }}>
                    {item.description && item.description.length > 50
                      ? `${item.description.substring(0, 50)}...`
                      : item.description || ""}
                  </p6>
                  <div className="service-card-action-btn">
                    <Button
                      variant="link"
                      onClick={() => handleShowModal(item, index)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="currentColor"
                        className="bi bi-arrow-right-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
                        />
                      </svg>
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <div className="model-comp">
        {" "}
        {/* Modal Component with smooth transitions */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          className={`services-popup ${isClosing ? "closing" : ""}`}
          size="lg"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{selectedService?.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedService ? (
              <div style={{ height: "100%", position: "relative" }}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Service Details</h5>
                  <span className={`badge ${selectedService.type}-color`}>
                    {selectedService.type === 'one-time'
                      ? 'Documentation'
                      : selectedService.type === 'renewal'
                      ? 'Documentation Renewal'
                      : selectedService.type}
                  </span>
                </div>
                <p className="py-3 fs-6">{selectedService.description}</p>
                {/* Add any other details from selectedService */}
              </div>
            ) : (
              <p>Loading service details...</p>
            )}
          </Modal.Body>
          <Modal.Footer className="services-popup-footer">
            <button
              type="button"
              onClick={PrevServices}
              className="btn btn-primary primary-btn"
              disabled={selectedServiceIndex === 0}
            >
              Prev
            </button>
            <button
              onClick={NextService}
              className="btn btn-primary primary-btn"
              disabled={selectedServiceIndex === filteredServices.length - 1}
            >
              Next
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default Services;
